<div
  class="wrapper"
  [class.disabled-control]="isEdit && !isEditable"
>
  @if (isPossibleToEdit()) {
    <input
      matInput
      [(ngModel)]="value"
      (blur)="onInputBlur()"
      [matDatepicker]="picker"
      [required]="required"
    />
    <div class="toggle">
      <mat-datepicker-toggle
        matIconSuffix
        [for]="picker"
      ></mat-datepicker-toggle>
      @if (isFilter) {
        <mat-datepicker-toggle matSuffix>
          <mat-icon matDatepickerToggleIcon>clear</mat-icon>
        </mat-datepicker-toggle>
      }
    </div>
    <mat-datepicker
      #picker
      startView="multi-year"
      panelClass="year-picker"
      (yearSelected)="handleYearInputChange($event, picker)"
    >
    </mat-datepicker>
  } @else {
    <input
      matInput
      disabled
      class="none-pointer-events"
      [value]="value"
    />
  }
</div>
